module.exports = __webpack_public_path__ + "fonts/KrungthaiFastWeb-ExtraBold.c24efe5d.ttf";